export default {
  '#___gatsby, #gatsby-focus-wrapper': { all: 'inherit' },
  '[data-sticky]:not([data-sticky="sticky"])': { visibility: 'hidden', position: 'absolute' },
  '[data-smoother-wrapper]': { willChange: 'transform' },
}
